import React from 'react';

const DEFAULT_STATE = {};

export const SelecaoModeloInteresseContext = React.createContext(DEFAULT_STATE);
